import LoadingIconImg from 'components/ChoreoSystem/Images/Various/LoadingIconGray.svg';

const LoadingIcon = () => (
  <img
    src={LoadingIconImg}
    alt="loading icon"
    style={{ width: 16, height: 16 }}
  />
);

export default LoadingIcon;
